import { Vue, Component, Ref, Prop, Emit, Provide } from 'vue-property-decorator'
import IncidentTypesConfigurationServices from '@/api/resources/configuration/incidents/types/IncidentTypesConfigurationServices'
import ConfigurationFieldsTranslations from '@/modules/configurationModule/shared/components/configuration-fields-translations/configuration-fields-translations.vue'
import { Nullable } from '@/shared/types/app.types'
import {
    ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest,
    ConfigurationIncidentsTypesLaboratoriesResponse
} from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.dto'
import {
    ConfigurationIncidentsTypesLaboratoriesModalState,
    initialConfigurationIncidentsTypesLaboratoriesModalState
} from '@/modules/configurationModule/detail/incidents/incidents-types/components/incidents-types-modal/incidents-types-modal.model'
import { ConfigurationIncidentTypeResponse } from '@/modules/configurationModule/detail/incidents/incidents-types/models/incidents-types.dto'
import { incidentsSeveritiesConfigurationServices } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.service'
import { IncidentSeverityResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.dto'
import { TranslationRequest, TranslationResponse } from '@/api/services/common.dto'

@Component({
    components: {
        ConfigurationFieldsTranslations
    }
})
export default class IncidentsTypesModal extends Vue {
    @Ref() readonly incidentsTypesModal!: any

    @Prop(Boolean) readonly isGlobal!: boolean

    @Provide() externalValidator = this.$validator

    @Emit()
    update(): ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest[] {
        let updateRequest: ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest = {
            active: this.state.active,
            incidentSeverityId: this.state.incidentSeverity?.id,
            incidentTypeId: this.state.incidentType?.id,
            reportFileName: this.state.reportFileName,
            reportTitleTranslations: this.mapTranslationsToRequest(this.state.reportTitleTranslations),
            id: this.state.id
        }
        return [updateRequest]
    }

    @Emit()
    create(): ConfigurationIncidentsTypesLaboratoriesCreateAndPatchRequest {
        return {
            active: this.state.active,
            incidentSeverityId: this.state.incidentSeverity?.id,
            incidentTypeId: this.state.incidentType?.id,
            reportFileName: this.state.reportFileName,
            reportTitleTranslations: this.mapTranslationsToRequest(this.state.reportTitleTranslations)
        }
    }

    state: ConfigurationIncidentsTypesLaboratoriesModalState

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    get actionTitle(): string {
        return this.state.id ? this.$t('configuration.actions.update').toString()
            : this.$t('configuration.actions.add').toString()
    }

    get disabledIncidentTypeCombo(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        const modelValidated: boolean = !this.state.id ? !!this.state.incidentType : true
        return !hasErrors && isDirty && modelValidated
    }

    constructor() {
        super()
        this.state = initialConfigurationIncidentsTypesLaboratoriesModalState()
    }

    async show(selectedRow: Nullable<ConfigurationIncidentsTypesLaboratoriesResponse>): Promise<void> {
        await this.initializeIncidentType(selectedRow)
        this._showModal()
    }
    mapTranslationsToRequest(translations: TranslationResponse[]): TranslationRequest[] {
        return translations.map(translation => {
            return {
                languageId: translation.language.id,
                value: translation.value
            }
        })
    }
    private _showModal(): void {
        this.incidentsTypesModal.show()
    }

    async initializeIncidentType(incidentType: Nullable<ConfigurationIncidentsTypesLaboratoriesResponse>): Promise<void> {
        this.state = initialConfigurationIncidentsTypesLaboratoriesModalState()
        await this.$validator.reset()
        if (incidentType) {
            this.state = {
                id: incidentType.id,
                active: incidentType.active,
                incidentType: incidentType.incidentType,
                incidentSeverity: incidentType.incidentSeverity,
                reportTitleTranslations: incidentType.reportTitleTranslations,
                reportFileName: incidentType.reportFileName
            }
        }
    }

    private async _getAllIncidentTypes(): Promise<ConfigurationIncidentTypeResponse[] | void> {
        const params = {}
        const [err, data] = await this.$_toCall(IncidentTypesConfigurationServices.paginator({}, params))
        if (err) {
            return
        }
        return data.content
    }

    private async _getAllIncidentSeverities(): Promise<IncidentSeverityResponse[] | void> {
        const params = {}
        const [err, data] = await this.$_toCall(incidentsSeveritiesConfigurationServices.paginator({}, params))
        if (err) {
            return
        }
        return data.content
    }
    actionModal(): void {
        if (this.state.id) {
            this.update()
        } else {
            this.create()
        }
    }

    hide(): void {
        this.incidentsTypesModal.hide()
    }
}
